import React from "react";
import { Container } from "react-bootstrap";
import PortfolioCard from "./PortfolioCard";
import db from "../db";

const Portfolio = () => {
  return (
    <div className="pink_background">
      <Container
        className="my-5"
        style={{
          alignContent: "center",
          margin: "10px",
          width: "100vh",
          maxWidth: "100vw",
        }}
      >
        {db.portfolio.map((item, index) => (
          <PortfolioCard
            key={index}
            image={item.image}
            youtubeId={item.youtubeId}
            poster={item.poster}
            source={item.source}
            title={item.title}
            descriptions={item.descriptions}
            listItems={item.listItems}
            buttons={item.buttons}
          />
        ))}
      </Container>
    </div>
  );
};

export default Portfolio;
